import cookie from 'cookie';
import {gladiatorService} from '@jobseeker/common-core/services';
import {COOKIE_LOGIN_AUTH} from '@jobseeker/common-core/constants';
import type {GetServerSidePropsContext} from 'next/types';

const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
const isAppHirist = process.env.NEXT_PUBLIC_APP_NAME === 'hirist';

export async function getSalaryNudgeVariant(
  context: GetServerSidePropsContext
): Promise<'A' | 'control' | undefined> {
  if (!isAppIimjobs && !isAppHirist) return undefined;

  const experimentId = parseInt(
    process.env.NEXT_PUBLIC_SALARY_NUDGE_EXPERIMENT_ID ?? '0',
    10
  );
  if (!experimentId) return undefined;

  try {
    const cookieHeader = context.req?.headers?.cookie;
    const abCookies = cookieHeader ? cookie.parse(cookieHeader) : {};
    const tDsCookie = abCookies?.['_t_ds'];

    if (!tDsCookie) return undefined;

    let sessionToken: string | undefined;
    if (abCookies?.[COOKIE_LOGIN_AUTH]) {
      const validateInfo = await gladiatorService.validate('validate', {
        headers: {cookie: cookieHeader},
      });
      sessionToken = validateInfo?.token;
    }

    if (!sessionToken) return undefined;

    const abResponse = await fetch(
      `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_AB_TEST}/get-variant?experimentId=${process.env.NEXT_PUBLIC_SALARY_NUDGE_EXPERIMENT_ID}`,
      {
        method: 'GET',
        headers: {
          referer: `https://www.${process.env.NEXT_PUBLIC_APP_DOMAIN}/`,
          Authorization: `Bearer ${sessionToken}`,
          cookie: `_t_ds=${tDsCookie}`,
          _t_ds: tDsCookie,
        },
      }
    );

    const abData = await abResponse.json();
    const variantName = abData?.data?.variant?.name;
    if (!variantName) return 'control';
    return variantName === 'control' ? 'control' : 'A';
  } catch {
    return undefined;
  }
}
